import { APARTMENTS, COMMERCIALS, GARAGES, LANDS, RENT, RENTDAILY, SALE } from '../consts';

const dateGroup = {type: 'group', value: 'По дате'};
const dateInsertedGroup = {type: 'group', value: 'По дате добавления'};
const dateUpdatedGroup = {type: 'group', value: 'По дате обновления'};
const priceGroup = {type: 'group', value: 'По цене'};
const pricePerMeterGroup = {type: 'group', value: 'По цене за кв.м.'};
const pricePerMeterOrArGroup = {type: 'group', value: 'По цене за кв.м./сот.'};
const areaGroup = {type: 'group', value: 'По площади'};
const areaHouseGroup = {type: 'group', value: 'По площади дома'};
const areaLandGroup = {type: 'group', value: 'По площади участка'};
const streetNameGroup = {type: 'group', value: 'По названию улицы'};

const insertedAscOption = {type: 'option', value: 'inserted', label: 'сначала старые'};
const insertedDesOption = {type: 'option', value: '-inserted', label: 'сначала новые'};
const updatedAscOption = {type: 'option', value: 'updated', label: 'сначала старые'};
const updatedDesOption = {type: 'option', value: '-updated', label: 'сначала новые'};

const priceAscOption = {type: 'option', value: 'price', label: 'сначала недорогие'};
const priceDesOption = {type: 'option', value: '-price', label: 'сначала дорогие'};
const pricePerMeterAscOption = {type: 'option', value: 'pricePerSquareMeter', label: 'сначала недорогие'};
const pricePerMeterDesOption = {type: 'option', value: '-pricePerSquareMeter', label: 'сначала дорогие'};
const pricePerMeterOrArAscOption = {type: 'option', value: 'pricePerSquareMeterOrAr', label: 'сначала недорогие'};
const pricePerMeterOrArDesOption = {type: 'option', value: '-pricePerSquareMeterOrAr', label: 'сначала дорогие'};

const areaAscOption = {type: 'option', value: 'squareTotal', label: 'сначала небольшие'};
const areaDesOption = {type: 'option', value: '-squareTotal', label: 'сначала большие'};
const areaLandAscOption = {type: 'option', value: 'squareLand', label: 'сначала небольшие участки'};
const areaLandDesOption = {type: 'option', value: '-squareLand', label: 'сначала большие участки'};
const areaHouseAscOption = {type: 'option', value: 'squareHouse', label: 'сначала небольшие дома'};
const areaHouseDesOption = {type: 'option', value: '-squareHouse', label: 'сначала большие дома'};

const streetNameAscOption = {type: 'option', value: 'streetName', label: 'от А до Я'};
const streetNameDesOption = {type: 'option', value: '-streetName', label: 'от Я до А'};

const objectTypeOption = {type: 'option', value: 'objectTypeId', label: 'по типу жилья'};
const floorOption = {type: 'option', value: 'floor', label: 'этаж'};
const initialOption = {type: 'option', value: null, label: 'по умолчанию'};

const dictionary = {};
dictionary[SALE + APARTMENTS] = [
  initialOption,
  dateGroup, insertedDesOption, insertedAscOption,
  priceGroup, priceAscOption, priceDesOption,
  pricePerMeterGroup, pricePerMeterAscOption, pricePerMeterDesOption,
  areaGroup, areaAscOption, areaDesOption,
  streetNameGroup, streetNameAscOption, streetNameDesOption,
  objectTypeOption
];

dictionary[RENT + APARTMENTS] = [
  initialOption,
  dateGroup, insertedDesOption, insertedAscOption,
  priceGroup, priceAscOption, priceDesOption,
  areaGroup, areaAscOption, areaDesOption,
  streetNameGroup, streetNameAscOption, streetNameDesOption
];

dictionary[RENTDAILY + APARTMENTS] = [
  initialOption,
  dateGroup, insertedDesOption, insertedAscOption,
  priceGroup, priceAscOption, priceDesOption,
  areaGroup, areaAscOption, areaDesOption,
  streetNameGroup, streetNameAscOption, streetNameDesOption
];

dictionary[SALE + COMMERCIALS] = [
  initialOption,
  dateGroup, insertedDesOption, insertedAscOption,
  priceGroup, priceAscOption, priceDesOption,
  pricePerMeterGroup, pricePerMeterAscOption, pricePerMeterDesOption,
  areaGroup, areaAscOption, areaDesOption,
  streetNameGroup, streetNameAscOption, streetNameDesOption,
  objectTypeOption
];

dictionary[RENT + COMMERCIALS] = [
  initialOption,
  priceGroup, priceAscOption, priceDesOption,
  pricePerMeterGroup, pricePerMeterAscOption, pricePerMeterDesOption,
  dateInsertedGroup, insertedDesOption, insertedAscOption,
  dateUpdatedGroup, updatedAscOption, updatedDesOption,
  streetNameGroup, streetNameAscOption, streetNameDesOption,
  objectTypeOption,
  floorOption
];

dictionary[SALE + GARAGES] = [
  initialOption,
  priceGroup, priceAscOption, priceDesOption,
  dateInsertedGroup, insertedDesOption, insertedAscOption,
  dateUpdatedGroup, updatedAscOption, updatedDesOption,
  streetNameGroup, streetNameAscOption, streetNameDesOption,
  objectTypeOption
];

dictionary[SALE + LANDS] = [
  initialOption,
  dateGroup, insertedDesOption, insertedAscOption,
  priceGroup, priceAscOption, priceDesOption,
  pricePerMeterOrArGroup, pricePerMeterOrArAscOption, pricePerMeterOrArDesOption,
  areaHouseGroup, areaHouseAscOption, areaHouseDesOption,
  areaLandGroup, areaLandAscOption, areaLandDesOption,
  streetNameGroup, streetNameAscOption, streetNameDesOption,
  objectTypeOption
];

export default function getSortItems (dealType, realtyType) {
  return dictionary[dealType + realtyType];
};



// WEBPACK FOOTER //
// ./src/utils/sorting.js